import {useQuery} from "@tanstack/react-query";
import {getUserAccessQueryOptions} from "./get-user-access.query-options";

export function useGetUserAccess(userId: string) {
  return useQuery(getUserAccessQueryOptions(userId));
}
